module.exports = __webpack_public_path__ + "static/media/logo_pink.5e908af3.webp";